import React from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Alert from "@mui/material/Alert";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";

const useStyles = makeStyles()({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "left",
    width: "100%",
    padding: "0px 15px",
    textAlign: "left",
    minHeight: "250px",
  },
  inputLabelGrid: {
    alignSelf: "center",
  },
  inputLabel: {
    fontSize: "16px",
    fontWeight: "Bold",
    display: "inline-flex",
    whiteSpace: "normal",
  },
  inputLabelValue: {
    whiteSpace: "normal",
  },
});

export default function UpdateClientIDClientSecret({
  enable,
  setEnable,
  clientID,
  setClientID,
  clientSecret,
  setClientSecret,
  OIDCData,
}) {
  const { classes } = useStyles();

  return (
    <Box sx={{ width: "100%" }} component="form" className={classes.formContainer}>
      <Grid container spacing={2} style={{ marginTop: "10px" }}>
        <Grid size={12}>
          <Alert severity="info">You will need to configure your OIDC Issuer with the below information:</Alert>
        </Grid>
        <Grid size={3}>
          <InputLabel className={classes.inputLabel}> Grant Type : </InputLabel>
        </Grid>
        <Grid size={9}>
          <InputLabel className={classes.inputLabelValue}>{OIDCData.GrantType}</InputLabel>
        </Grid>
        <Grid size={3}>
          <InputLabel className={classes.inputLabel}> Callback URL : </InputLabel>
        </Grid>
        <Grid size={9}>
          <InputLabel className={classes.inputLabelValue}>{OIDCData.CallbackURL}</InputLabel>
        </Grid>
        <Grid size={3}>
          <InputLabel className={classes.inputLabel}> Logout URL : </InputLabel>
        </Grid>
        <Grid size={9}>
          <InputLabel className={classes.inputLabelValue}>{OIDCData.LogoutURL}</InputLabel>
        </Grid>

        <Grid className={classes.inputLabelGrid} size={3}>
          <InputLabel className={classes.inputLabel}> Client ID* : </InputLabel>
        </Grid>

        <Grid size={9}>
          <TextField
            margin="dense"
            fullWidth
            label="Client ID"
            variant="outlined"
            value={clientID}
            onChange={(e) => setClientID(e.target.value)}
            required
          />
        </Grid>
        <Grid className={classes.inputLabelGrid} size={3}>
          <InputLabel className={classes.inputLabel}> Client Secret* : </InputLabel>
        </Grid>
        <Grid size={9}>
          <TextField
            margin="dense"
            type="password"
            fullWidth
            label="Client Secret"
            variant="outlined"
            value={clientSecret}
            onChange={(e) => setClientSecret(e.target.value)}
            required
          />
        </Grid>

        <Grid size={12}>
          <FormControlLabel
            control={
              <Checkbox
                value={+enable}
                checked={enable !== undefined && enable ? true : false}
                onChange={(e) => setEnable(e.target.checked)}
              />
            }
            label="Everything is ready, enable this connection!"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
